import ChatIndex from 'pages/meddelanden'

export default ChatIndex
